module.exports = __webpack_public_path__ + "static/img/404.5c17595f.png";